import React from 'react';
import PropTypes from 'prop-types';
import CustomSelect from '../select/CustomSelect';
import useStyle from './ButtonWithOptionsStyle';
import Utils from '../../../services/UtilsService';

// Modified by AI on 05/26/2026. Edit #1.
const ButtonWithOptions = ({
    className = '',
    label = '',
    options = [],
    color,
    onButtonClick = () => {},
    onOptionClick = () => {},
    placement,
    isLoading,
}) => {
    const classes = useStyle({ color });
    const rootClasses = Utils.getClassName([
        classes.root,
        className,
    ]);

    const buttonOption = { label, value: label, isHidden: true };
    const resultOptions = [buttonOption, ...options];

    return (
        <CustomSelect
            className={rootClasses}
            color={color}
            isLoading={isLoading}
            isLeftAligned={false}
            placement={placement}
            selectedValue={buttonOption.value}
            selectOptions={resultOptions}
            onButtonClick={onButtonClick}
            onOptionSelect={onOptionClick}
        />
    );
};

ButtonWithOptions.propTypes = {
    className: PropTypes.string,
    color: PropTypes.oneOf([
        'primary',
        'secondary',
        'transparent',
    ]),
    label: PropTypes.string,
    options: PropTypes.array,
    onButtonClick: PropTypes.func,
    onOptionClick: PropTypes.func,
};

export default ButtonWithOptions;
